import MarketingLayout from "@/components/MarketingLayout";
import ToolPageNew from "@/pages/newsite/ToolPageNew";

export default function TikTokAdsSearchPage() {
  return (
    <MarketingLayout>
      <ToolPageNew />
    </MarketingLayout>
  );
}
